
export const getCardActivityService = (actionCallback, id, startDate, endDate, statementPeriod,transactionType) => {
    let token = "Token " + localStorage.getItem('token')
    let baseUrl= localStorage.getItem('serviceUrl')

    const state = {
        activityFromDate: startDate || "",
        activityToDate: endDate || "",
        applicationId: localStorage.getItem('applicationId'),
        cardReferenceId: localStorage.getItem('cardRefNumber'),
        statementPeriod: statementPeriod ,
        transactionType:transactionType
    }
    fetch(baseUrl + "/public/card/getCardActivityByCardReferenceId",{
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(state)

    })
    .then(res => {
        if (res.status === 200 || res.status === 201) {
            res.json().then(json => actionCallback(json, "success", res.status))
        } else if (res.status === 204) {
            actionCallback({ "transactions": [] }, "success", res.status)
        } else {
            actionCallback([], res.headers.get('message'), res.status)
        }
    })
}


// WEBPACK FOOTER //
// ./src/services/components/get_cardactivity.jsx